import { isEmpty } from 'tools/string'
import logger from 'tools/logger'
import { postLogApi } from 'api/newrelic/client'
import { APP_NAME, isBrowser } from 'env'

export const logApiError = async ({ req, response, apiRoot, origin, extendLogs = '' }) => {
  let statusCode, url, errorBody

  try {
    if (isBrowser()) {
      statusCode = response.status
      url = response.url
      errorBody = await response.text()
    } else {
      statusCode = response.statusCode
      url = response.request.uri.href
      errorBody = response.body
    }

    const shouldLogResponse = parseInt(statusCode) >= 400
    if (shouldLogResponse) {
      const message = `${APP_NAME}: Error calling ${url} ${extendLogs} with ${statusCode} status code - ${errorBody}`.substring(0, 1000)
      await postLogApi({ req, origin, apiRoot, payload: { message } })
      logger.error(message)
    }
  } catch (e) {
    // do nothing to prevent noise
  }
}

export const createErrorString = ({ t, error, fallbackError = 'error_general' }) => {
  const _errors = Array.isArray(error) ? error : [error]
  const errors = _errors.map(error => {
    const errorMessage = typeof error === 'string' ? error : error.errorCode
    return !isEmpty(errorMessage) ? t(errorMessage) : t(fallbackError)
  })
  return errors || []
}
